<template>
  <form>
    <div class="row justify-content-md-center mb-2">
      Folgende Transaktion soll storniert werden:
    </div>
    <div class="row justify-content-md-center">
      <div class="table-striped table-bordered table-responsive" style="max-width: 700px">
        <table class="table table-sm" style="" id="transaction-info">
          <thead class="thead-light">
          <tr>
            <!--<th>#</th>-->
            <th>ID</th>
            <th>Datum</th>
            <th>Buchungstext</th>
            <th>Konto</th>
            <th>Gutschrift</th>
            <th>Belastung</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ $filters.cleanId(t_transaction_id) }}</td>
            <td>{{ $filters.formatDate(t_date) }}</td>
            <td>{{ t_text }}</td>
            <td>{{ $filters.formatExpenseIncomeAccounts(t_txAcc) }}</td>
            <td></td>
            <td align="right">
              <span class="badge badge-danger">{{ t_amount }}</span>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ $filters.formatExpenseIncomeAccounts(t_rxAcc) }}</td>
            <td align="right">
              <span class="badge badge-success">{{ t_amount }}</span>
            </td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="form-row">
      <div class="col-8">
        <label for="subject">Storno-Grund</label>
        <input
            v-model="t_reason"
            type="text"
            class="form-control"
            id="subject"
            placeholder="Storno-Grund"
            title="Grund für die Stornierung"
            @keydown.enter.prevent
        >
      </div>
      <div class="col">
        <label for="receiptInfo">Belegnummer</label>
        <input v-model="t_receiptInfo" disabled type="text" class="form-control" id="receiptInfo"
               placeholder="Beleg-ID">
      </div>
    </div>
    <div v-if="t_action_type==='OUTPUT'" class="form-row d-flex justify-content-end">
      <div class="p-0">
        <a v-on:click="perform('INPUT', $event)" v-on:submit.prevent="onSubmit" class="btn btn-primary" href="#" role="button">
          Storno durchführen
        </a>
      </div>
    </div>
    <div v-else class="form-row d-flex justify-content-end">
      <div class="p-0">
        <button v-on:click="perform('OUTPUT', $event)" v-on:submit.prevent="onSubmit" class="btn btn-primary">
          Storno durchführen
        </button>
      </div>
    </div>

  </form>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'BookReverseEntry',
  props: ['editor_data'],
  components: {
    Datepicker
  },
  data() {
    return {
      account: 'Default',
      error_msg: 'No Error',
      t_text: '',
      t_receiptInfo: '',
      t_counterAcc: '',
      t_amount: '',
      t_date: '',
      t_reason: '',
      t_transaction_id: -1,
      t_action_type: 'INPUT',
      en: en,
      de: de,
    }
  },
  mounted: function () {
    this.t_text = this.editor_data.t_text
    this.t_counterAcc = this.editor_data.t_counterAcc
    this.t_amount = this.editor_data.t_amount
    this.t_transaction_id = this.editor_data.t_transaction_id
    this.t_action_type = this.editor_data.t_action_type
    this.t_receiptInfo = this.editor_data.t_receiptInfo
    this.t_txAcc = this.editor_data.t_txAcc
    this.t_rxAcc = this.editor_data.t_rxAcc
    this.t_date = this.editor_data.t_date
  },
  methods: {
    perform(actionType, event) {
      event.preventDefault();
      if (this.t_counterAcc == 0) {
        return;
      }
      if (!confirm('Buchung bestätigen?')) {
        return;
      }
      var t_id = this.$filters.cleanId(this.t_transaction_id);
      var today = this.$filters.formatDate(new Date());
      var text = "Storno vom: " + today + " ID: " + t_id + " Grund: " + this.t_reason
      const data = new FormData();
      var accName = this.t_action_type == 'INPUT' ? this.t_rxAcc : this.t_txAcc
      data.append('accName', accName)
      data.append('counterAcc', this.t_counterAcc)
      data.append('receiptInfo', this.t_receiptInfo)
      data.append('date', this.$filters.formatDate(this.t_date))
      data.append('text', text)
      data.append('amount', this.t_amount)
      data.append('actionType', actionType)
      data.append('reverts', this.t_transaction_id)
      var credentials = JSON.parse(localStorage.getItem('credentials'))
      var msg = {type: "NONE"}
      axios({
        url: process.env.VUE_APP_ROOT_API
            + '/account/'
            + accName
            + '/entries',
        data: data,
        auth: credentials,
        method: 'post'
      }).catch(e => {
        // eslint-disable-next-line
        console.log("Error in reverting");
        // eslint-disable-next-line
        console.log(e);
      }).then(resp => {
        msg = resp.data
        // eslint-disable-next-line
        console.log("Message")
        // eslint-disable-next-line
        console.log(msg)
        if (!(msg.type == "NONE")) {
          // eslint-disable-next-line
          console.log("Pushing error")
          this.$store.commit('add_message', msg)
        }
        this.$store.dispatch('loadCurrentAccount');
        this.$store.dispatch('loadAccounts');
      });

      this.$emit('delete-tab')
    }
  },
  computed: {
    accountName() {
      return this.$store.state.current_acc
    },
  }
}
</script>

<style scoped>

</style>

